import { convertNumberToCurrency } from '../../utils.js';
export const NON_NUMERIC = /\D+/g;
export const RATES = { personal: { rate: '4.05', label: '4.05%' }, business: { rate: '2.50', label: '2.50%' } };

export const isValidDepositAmount = (amount) => {
  return amount > 1999 && amount <= 1000000;
};

export const calculateAmountWithInterest = (amount, rate) => {
  const total = (amount * rate) / 100 + amount;
  return convertNumberToCurrency(total, 'en-GB', 'GBP');
};

export const calculateInterest = (amount, rate) => {
  const interest = (amount * rate) / 100;
  return convertNumberToCurrency(interest, 'en-GB', 'GBP');
};

export const cleanDepositAmount = (amount, regex) => {
  if (amount === '') return 0;

  // Remove regex chars from our string
  return Number(amount.replace(regex, ''));
};
